<template>
  <tfoot v-show="data.length">
    <tr class="-summary-row">
      <td class="td" v-if="shouldRenderSelection"></td>
      <template v-for="(col, idx) in columns">
        <!-- display the available fields only -->
        <td class="td" v-if="typeof summary[col.field] == 'object'?summary[col.field][col.nested]:summary[col.nested||col.field]" :class="col.tdClass" :style="col.tdStyle">
          <!-- <td> component (tdComp) -->
          <component
            v-if="col.tdComp"
            :is="forDynCompIs(col.tdComp)"
            :row="summary"
            :field="col.nested||col.field"
            :value="typeof summary[col.field] == 'object'?summary[col.field][col.nested]:summary[col.nested||col.field]"
            v-bind="$props">
          </component>
          <template v-else>
            {{ typeof summary[col.field] == 'object'?summary[col.field][col.nested]:summary[col.nested||col.field] }}
          </template>
        </td>
        <td class="td" v-else :class="col.tdClass" :style="col.tdStyle"></td>
      </template>
    </tr>
  </tfoot>
</template>
<script>
import props from '../_mixins/props'
import shouldRenderSelection from '../_mixins/shouldRenderSelection'

export default {
  name: 'TableFooter',
  mixins: [props, shouldRenderSelection]
}
</script>
<style>
.-summary-row {
  background-color: #eee !important;
  font-size: 1.10rem;
  font-weight: 700;
}
.-summary-row td {
  padding: 1.50rem 1.25rem 0.50rem 1.25rem !important;
  text-align: left;
  position: sticky;
  bottom: 0px;
  background-color: #eee !important;
  color: #000;
  z-index: 1007;
}
.td {
    border: 0px solid #d6dee5 !important;
}
.-summary-row .td.leftfixed{
  position: sticky;
  left: 0;
  z-index: 1008 !important;
}
</style>
